import { render, staticRenderFns } from "./DriverTypes.vue?vue&type=template&id=4b8ef524&"
import script from "./DriverTypes.vue?vue&type=script&lang=ts&"
export * from "./DriverTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports